import { useEffect, useState } from "react";
import TeacherPortalLearningMaterialUsageTimelineChart from "./LearningMaterialUsage";
import Icon from "../../../general/Icon";

const TeacherPortalLearningMaterial = ({ activityWithUsageData, hasBeenOpen }) => {
    const [body, setBody] = useState(null);
    const generateTimeline = () => <TeacherPortalLearningMaterialUsageTimelineChart activityWithUsageData={activityWithUsageData} />;

    useEffect(() => {
        if (hasBeenOpen && body === null) setTimeout(() => setBody(generateTimeline()), 100);
    }, [hasBeenOpen])

    return <div className="w-full rounded bg-card shadow-default">
        <div className="p-4">
            <div className="flex items-center">
                <Icon size={60} type={activityWithUsageData.activitytype} color="black" />
                <h2 className="ml-4 text-xl font-semibold">{activityWithUsageData.activitytitle}</h2>
            </div>
            <div className="mt-4 grid grid-cols-12 gap-4">
                <section className="col-span-2 h-full rounded bg-white p-2 shadow-default">
                    <h3 className="text-lg font-semibold">Usage Information</h3>
                    <p className="text-left text-sm">Accessed by <b>{activityWithUsageData.total_usage_data.count_users}</b> users in lifetime</p>
                    <p className="text-sm">Accessed by <b>{activityWithUsageData.total_usage_data.count_users_last_30_days}</b> users in the last 30 days</p>
                </section>
                <div className="col-span-10">{body}</div>
            </div>
        </div>
    </div>
}

export default TeacherPortalLearningMaterial;
